import React, {Fragment} from 'react'

// Material-UI Core
import {makeStyles} from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Slide from '@material-ui/core/Slide'

// Custom Style
import {oceanBlueColor} from '../../styles/jss/cmsMainStyle'
import {confirmDialogStyle} from '../../styles/jss/components/dialog/confirmDialogStyle'

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />
})

const useStyles = makeStyles(theme => confirmDialogStyle(theme))

const ConfirmDialog = props => {
	const classes = useStyles()
	const {open, dialogTitle, dialogContent, attentionContent, confirmAction, cancelAction} = props

	return (
		<Fragment>
			<Dialog
				open={open}
				TransitionComponent={Transition}
				fullWidth={true}
				// onClose={handleClose}
				aria-labelledby="confirmDialogTitle"
				aria-describedby="confirmDialogDescription"
				PaperProps={{
					style: {
						background:	"linear-gradient(0deg, " + oceanBlueColor[4] + ", " + oceanBlueColor[0] + ")",
					},
				}}
			>
				<DialogTitle id="confilmDialogTitle">
					{dialogTitle}
				</DialogTitle>

				<DialogContent>
					<DialogContentText id="confirmDialogContent" className={classes.content}>
						{dialogContent}
					</DialogContentText>

					<DialogContentText id="confirmDialogContent" className={classes.attentionContent}>
						{attentionContent ? "Attention: " + attentionContent : ""}
					</DialogContentText>
				</DialogContent>

				<DialogActions>
					<Button onClick={cancelAction} className={classes.actionButton} autoFocus>
						Cancel
					</Button>

					<Button onClick={confirmAction} className={classes.actionButton}>
						Confirm
					</Button>
				</DialogActions>

			</Dialog>
		</Fragment>
	)
}


export default ConfirmDialog
